import React, { useEffect } from 'react';
import { CheckCircle } from 'lucide-react';

interface SuccessProps {
    clearCart: () => void;
    onNavigate: (page: string) => void;
}

export const Success: React.FC<SuccessProps> = ({ clearCart, onNavigate }) => {
    useEffect(() => {
        // Limpiar el carrito una vez que el pago fue exitoso
        clearCart();
    }, [clearCart]);

    return (
        <div className="min-h-[70vh] flex flex-col items-center justify-center p-4 bg-gray-50 text-center animate-in fade-in zoom-in duration-500">
            <div className="bg-white p-10 rounded-3xl shadow-xl max-w-lg border border-green-100 flex flex-col items-center">
                <div className="w-24 h-24 bg-green-100 text-green-600 rounded-full flex items-center justify-center mb-6 animate-bounce">
                    <CheckCircle size={48} strokeWidth={2.5} />
                </div>
                <h1 className="text-4xl font-serif font-bold text-gray-900 mb-4">¡Pago Completado!</h1>
                <p className="text-gray-600 mb-8 max-w-sm">
                    Tu transacción se ha procesado con éxito. Hemos enviado un recibo a tu correo electrónico junto con los detalles de tu pedido.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 w-full">
                    <button
                        onClick={() => onNavigate('home')}
                        className="flex-1 bg-gray-100 text-gray-800 py-3 px-6 rounded-full font-bold hover:bg-gray-200 transition-colors"
                    >
                        Volver al Inicio
                    </button>
                    <button
                        onClick={() => onNavigate('tienda')}
                        className="flex-1 bg-[#2C1810] text-white py-3 px-6 rounded-full font-bold hover:opacity-90 transition-opacity shadow-lg"
                    >
                        Seguir Comprando
                    </button>
                </div>
            </div>
        </div>
    );
};
